import type {JSX} from 'react';

import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';

/** Whether service-account Agent product surfaces are enabled (interaction, not creation). */
export function useIsRoutineServiceAccountUiEnabled(): boolean {
  const {llmEnableRoutineServiceAccountUi} = useRolloutFlags();
  return llmEnableRoutineServiceAccountUi === true;
}

export interface RoutineServiceAccountUiEnabledRenderProps {
  isRoutineServiceAccountUiEnabled: boolean;
}

/** Supplies {@link useIsRoutineServiceAccountUiEnabled} to class components and other non-hook call sites. */
export function GetRoutineServiceAccountUiEnabled({
  children,
}: {
  children: (props: RoutineServiceAccountUiEnabledRenderProps) => JSX.Element;
}): JSX.Element {
  const isRoutineServiceAccountUiEnabled = useIsRoutineServiceAccountUiEnabled();
  return children({isRoutineServiceAccountUiEnabled});
}
